import { createFileRoute } from "@tanstack/react-router";

import { ThreadPage } from "~/pages/thread/thread.page";

export const Route = createFileRoute("/_app/thread/$threadId")({
  component: ThreadPage,
});
